export default "__VITE_ASSET__50df0a89__"